import React from "react";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { SharedExerciseCard } from "@sophy/shared-ui";
import {
  parseExerciseSteps,
  getPrescriptionItems,
  getPlayerLabels,
  getBodyRegionTags,
} from "@features/programs/utils/exerciseCardData";

/**
 * The exercise as the patient sees it in their program — same card as in the
 * therapist app, fed from this app's payload shape.
 */
function ExerciseCard({ exercise, position = null }) {
  const { t } = useTranslation();

  const source = exercise?.source || {};
  const mapping = source.mapping_sources_translation?.[0];

  const name = mapping?.name || exercise?.name || "";
  const steps = parseExerciseSteps(mapping?.steps || source.steps);
  const prescription = getPrescriptionItems(exercise?.prescription, t);

  return (
    <SharedExerciseCard
      title={parse(String(name))}
      tags={getBodyRegionTags(source.body_region)}
      /* No video_url means the exercise is a still image; the card then drops
         the player instead of offering a play button that cannot play. */
      videoSrc={source.video_url || null}
      posterSrc={source.thumb_url || null}
      playerLabels={getPlayerLabels(t)}
      badge={position}
      steps={steps}
      showMoreLabel={t("exercise.showMore")}
      showLessLabel={t("exercise.showLess")}
      prescription={
        /* Unknown format: show the string the backend sent rather than
           mislabelling its parts. */
        prescription ||
        (exercise?.prescription ? [{ value: exercise.prescription }] : null)
      }
      note={exercise?.note || null}
    />
  );
}

export default ExerciseCard;
